import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/file.png'


const _hoisted_1 = { class: "border-outside" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "desc-flex" }
const _hoisted_4 = ["max"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "loading-flex" }
const _hoisted_7 = { class: "loading-title" }
const _hoisted_8 = { class: "progress-text" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "donwload-flex" }
const _hoisted_12 = { class: "donwload-desc" }
const _hoisted_13 = { class: "donwload-name-title" }
const _hoisted_14 = { class: "donwload-size-title" }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "font-title" }, "過去月の全スタッフ請求書のダウンロード ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-desc" }, "請求書のダウンロード", -1)),
        _withDirectives(_createElementVNode("input", {
          min: "2023-05",
          max: _ctx.currenYearMonth,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateMonth) = $event)),
          type: "month",
          class: "date-input",
          lang: "ja-JP"
        }, null, 8, _hoisted_4), [
          [_vModelText, _ctx.dateMonth]
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getFileFetch && _ctx.getFileFetch(...args))),
          class: "select-button"
        }, " 進める ")
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileEventStream, (fileEvent, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (fileEvent.progress !== 100)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", null, "お待ちください...", -1)),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(fileEvent.progress) + "%", 1)
                ]),
                _createElementVNode("progress", {
                  value: fileEvent.progress,
                  max: "100"
                }, null, 8, _hoisted_9)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createTextVNode(_toDisplayString(fileEvent.name) + " ", 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getDecodedSize(fileEvent.zipBytes)) + " Mb", 1)
                  ]),
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.onClickDonwload(fileEvent.zipBytes, fileEvent.name)),
                    class: "donwload-href"
                  }, "ダウンロード", 8, _hoisted_15)
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "circle-grey" }, [
                  _createElementVNode("img", { src: _imports_0 })
                ], -1))
              ])
            ]))
      ]))
    }), 128))
  ]))
}